"use client";

import React from "react";
import { MainLayout } from "@/components/layout/main-layout";
import { ResetPasswordForm } from "@/components/auth/reset-password-form";

export default function ResetPasswordPage() {
  return (
    <MainLayout>
      <section className="flex flex-col min-h-screen bg-background">
        <div className="container relative flex-1 flex items-center justify-center">
          <div className="w-full max-w-md space-y-6 px-4">
            <div className="flex flex-col space-y-2 text-center">
              <h1 className="text-2xl font-semibold tracking-tight">
                Reset your password
              </h1>
              <p className="text-sm text-muted-foreground">
                Enter your email address and we'll send you a link to reset your password
              </p>
            </div>
            <ResetPasswordForm />
          </div>
        </div>
      </section>
    </MainLayout>
  );
}